export const SMALL_HEIGHT = 73;
export const LARGE_HEIGHT = 80;
export const SMALL_HEADER_HEIGHT = 56;
export const SMALL_TEAMS_HEADER_HEIGHT = 68;
export const LARGE_HEADER_HEIGHT = 60;
